import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IProductos, IPromosEcommerce } from './../../../private/shared/models/productos';

@Component({
  selector: 'getm-promo-summary-modal',
  templateUrl: './promo-summary-modal.page.html',
  styleUrls: ['./promo-summary-modal.page.scss']
})
export class PromoSummaryModalPage implements OnInit {

  @Input() promo: IPromosEcommerce = {} as IPromosEcommerce;
  @Input() productosPromocion: IProductos[] = [];
  @Input() isResume: boolean = false;
  @Input() quantity: number = 1;



  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit(): void { }

  public onClose = () => this.modalCtrl.dismiss(false);

  public selectedAddPromo = (quantity: number) => this.quantity = quantity;

  public onEdit = () => this.modalCtrl.dismiss(true);

  public onConfirm = () => this.modalCtrl.dismiss(this.quantity);

}
